import { useMixContentQuery } from "graphql/generated";
import uniqBy from "lodash/uniqBy";
import { ComponentProps } from "react";
import { ContentSection } from "types/app";

import { ContentGridQuery } from "./ContentGridQuery";

type ContentGridMixContentQueryProps = Omit<
    ComponentProps<
        typeof ContentGridQuery<MixContentQuery, MixContentQueryVariables>
    >,
    "useQuery" | "extractor" | "updateQuery"
>;

export const ContentGridMixContentQuery = ({
    contentSection,
    variables,
    ...props
}: ContentGridMixContentQueryProps & {
    contentSection: ContentSection;
    variables: MixContentQueryVariables;
}) => {
    return (
        <ContentGridQuery<MixContentQuery, MixContentQueryVariables>
            useQuery={useMixContentQuery}
            extractor={(result) => result.mix_content}
            updateQuery={(previousQueryResult, { fetchMoreResult }) => {
                return {
                    mix_content: uniqBy(
                        [
                            ...previousQueryResult.mix_content,
                            ...fetchMoreResult.mix_content
                        ],
                        (item) => item.id
                    )
                };
            }}
            contentSection={contentSection}
            variables={variables}
            {...props}
        />
    );
};
